
const Pdate = (cell:any) => {
    return cell.value ? cell.value : '';
};

const Ddate = (cell:any) => {
    return cell.value ? cell.value : '';
};

const Name = (cell:any) => {
    return cell.value ? cell.value : '';
};

const Idno = (cell:any) => {
    return cell.value ? cell.value : '';
};

const Budget = (cell:any) => {
    return cell.value ? cell.value : '';
};


export {
    Pdate,
    Ddate,
    Name,
    Idno,
    Budget
};